export function initNewsletterForm() {
  const form = document.getElementById('gform_1');
  if (!form || typeof ccNewsletter === 'undefined') return;

  const wrapper = document.getElementById('gform_wrapper_1');
  const messageEl = wrapper.querySelector('.cc-form-message');
  const submitBtn = form.querySelector('#gform_submit_button_1');
  const emailInput = form.querySelector('#cc_email');

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const email = emailInput.value.trim();
    if (!email) return;

    // Disable button during submission
    submitBtn.disabled = true;
    const originalLabel = submitBtn.querySelector('.label').textContent;
    submitBtn.querySelector('.label').textContent = 'Sending...';
    messageEl.style.display = 'none';

    try {
      const formData = new FormData();
      formData.append('action', 'cc_newsletter_signup');
      formData.append('nonce', ccNewsletter.nonce);
      formData.append('email', email);

      const response = await fetch(ccNewsletter.ajaxUrl, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();

      messageEl.textContent = result.data?.message || (result.success ? 'Thanks for subscribing!' : 'Something went wrong.');
      messageEl.style.display = 'block';
      messageEl.className = 'cc-form-message ' + (result.success ? 'cc-form-message--success' : 'cc-form-message--error');

      if (result.success) {
        emailInput.value = '';
        // Re-show the label after clearing the field
        const label = form.querySelector('.gfield_label');
        if (label) {
          label.classList.remove('hidden');
        }
      }
    } catch (err) {
      messageEl.textContent = 'Network error. Please try again.';
      messageEl.style.display = 'block';
      messageEl.className = 'cc-form-message cc-form-message--error';
    } finally {
      submitBtn.disabled = false;
      submitBtn.querySelector('.label').textContent = originalLabel;
    }
  });
}
